namespace Gamification.Gamification {
    export namespace UtentiProdottiConProprietaService {
        export const baseUrl = 'Gamification/UtentiProdottiConProprieta';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiConProprietaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiConProprietaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiConProprietaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiConProprietaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiConProprieta/Create",
            Update = "Gamification/UtentiProdottiConProprieta/Update",
            Delete = "Gamification/UtentiProdottiConProprieta/Delete",
            Retrieve = "Gamification/UtentiProdottiConProprieta/Retrieve",
            List = "Gamification/UtentiProdottiConProprieta/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiConProprietaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
